import { Language } from '../types';

export const navigationTranslations: Record<Language, Record<string, string>> = {
  en: {
    // Navigation Menu
    solutions: "Solutions",
    industries: "Industries",
    consulting: "Consulting",
    resources: "Resources",
    aboutUs: "About us",
    contactUs: "Contact us",
    
    // Navigation
    services: "Services",
    content: "Content",
    allContent: "All Content",
    
    // Service Cards
    ecommerceTitle: "Ecommerce Automation Suite",
    ecommerceDesc: "Streamline your online business with our comprehensive automation tools designed to optimize inventory, pricing, and customer engagement processes.",
    dataPlatformTitle: "Tailored Organisational Data Platform",
    dataPlatformDesc: "Elevate your organization to data-driven operations with our structured approach, from use case definition to implementation of custom data warehouses and reporting solutions.",
    talkToDataTitle: "Talk to Your Data",
    talkToDataDesc: "Interact with your data using natural language queries through familiar chat interfaces like Slack, Teams, or Google Chat.",
    sasTitle: "SAS to Python Migrations",
    sasDesc: "Modernize your data analytics infrastructure by transitioning from legacy SAS systems to flexible, cost-effective Python-based solutions.",
    learnMore: "Learn more",

    // Main menu ("Where to start" dropdown)
    navWhereToStart: "Where to start",
    navGroupPlatform: "The platform",
    navRas: "Retail Automation Suite",
    navDataMaturity: "Where am I? · Data Maturity",
    navGroupConsulting: "Consulting services",
    navDataAdoption: "Data Adoption Change Management",
    navAiReadiness: "AI Readiness Assessment",
    navGroupPnl: "For the P&L",
    navDigitalCfo: "Digital CFO",
    navRetailProfit: "Retail Profit Management",
    navGroupDataStack: "For the data stack",
    navDataWarehousing: "Data Warehousing",
    navContextEngineering: "Context Engineering",
    navOpenMenu: "Open menu",
    navCloseMenu: "Close menu",
  },
  de: {
    // Navigation Menu
    solutions: "Lösungen",
    industries: "Branchen",
    consulting: "Beratung",
    resources: "Ressourcen",
    aboutUs: "Über uns",
    contactUs: "Kontaktieren Sie uns",
    
    // Navigation
    services: "Dienstleistungen",
    content: "Inhalt",
    allContent: "Alle Inhalte",
    
    // Service Cards
    ecommerceTitle: "E-Commerce-Automatisierungssuite",
    ecommerceDesc: "Optimieren Sie Ihr Online-Geschäft mit unseren umfassenden Automatisierungstools, die Bestands-, Preis- und Kundeninteraktionsprozesse optimieren.",
    dataPlatformTitle: "Maßgeschneiderte Unternehmens-Datenplattform",
    dataPlatformDesc: "Heben Sie Ihre Organisation auf datengetriebene Operationen mit unserem strukturierten Ansatz, von der Anwendungsdefinition bis zur Implementierung von benutzerdefinierten Data Warehouses und Reporting-Lösungen.",
    talkToDataTitle: "Sprechen Sie mit Ihren Daten",
    talkToDataDesc: "Interagieren Sie mit Ihren Daten mithilfe natürlicher Sprachabfragen über vertraute Chat-Schnittstellen wie Slack, Teams oder Google Chat.",
    sasTitle: "SAS zu Python Migrationen",
    sasDesc: "Modernisieren Sie Ihre Datenanalyseinfrastruktur durch den Übergang von Legacy-SAS-Systemen zu flexiblen, kostengünstigen Python-basierten Lösungen.",
    learnMore: "Mehr erfahren",
  },
  sk: {
    // Navigation Menu
    solutions: "Riešenia",
    industries: "Odvetvia",
    consulting: "Konzultácie",
    resources: "Zdroje",
    aboutUs: "O nás",
    contactUs: "Kontaktujte nás",
    
    // Navigation
    services: "Služby",
    content: "Obsah",
    allContent: "Všetok obsah",
    
    // Service Cards - using English as fallback for now
    ecommerceTitle: "Balík automatizácie e-commerce",
    ecommerceDesc: "Streamline your online business with our comprehensive automation tools designed to optimize inventory, pricing, and customer engagement processes.",
    dataPlatformTitle: "Prispôsobená organizačná dátová platforma",
    dataPlatformDesc: "Elevate your organization to data-driven operations with our structured approach, from use case definition to implementation of custom data warehouses and reporting solutions.",
    talkToDataTitle: "Hovorte s vašimi dátami",
    talkToDataDesc: "Interact with your data using natural language queries through familiar chat interfaces like Slack, Teams, or Google Chat.",
    sasTitle: "Migrácie zo SAS do Python",
    sasDesc: "Modernize your data analytics infrastructure by transitioning from legacy SAS systems to flexible, cost-effective Python-based solutions.",
    learnMore: "Zistiť viac",

    // Main menu ("Where to start" dropdown)
    navWhereToStart: "Kde začať",
    navGroupPlatform: "Platforma",
    navRas: "Retail Automation Suite",
    navDataMaturity: "Kde som? · Dátová zrelosť",
    navGroupConsulting: "Konzultačné služby",
    navDataAdoption: "Zavedenie dát do praxe",
    navAiReadiness: "Pripravenosť na AI",
    navGroupPnl: "Pre P&L",
    navDigitalCfo: "Digital CFO",
    navRetailProfit: "Retail Profit Management",
    navGroupDataStack: "Pre dátovú infraštruktúru",
    navDataWarehousing: "Dátové sklady",
    navContextEngineering: "Context Engineering",
    navOpenMenu: "Otvoriť menu",
    navCloseMenu: "Zavrieť menu",
  },
  cs: {
    // Navigation Menu
    solutions: "Řešení",
    industries: "Odbory",
    consulting: "Konzultace",
    resources: "Zdroje",
    aboutUs: "O nás",
    contactUs: "Kontaktujte nás",
    
    // Navigation
    services: "Služby",
    content: "Obsah",
    allContent: "Veškerý obsah",
    
    // Service Cards
    ecommerceTitle: "Balíček automatizace e-commerce",
    ecommerceDesc: "Zefektivněte své online podnikání pomocí našich komplexních automatizačních nástrojů navržených k optimalizaci procesů zásob, cenotvorby a zapojení zákazníků.",
    dataPlatformTitle: "Přizpůsobená organizační datová platforma",
    dataPlatformDesc: "Pozvedněte svou organizaci k datově řízeným operacím pomocí našeho strukturovaného přístupu, od definice případů užití po implementaci vlastních datových skladů a reportovacích řešení.",
    talkToDataTitle: "Mluvte se svými daty",
    talkToDataDesc: "Interagujte se svými daty pomocí přirozeného jazyka prostřednictvím známých chatovacích rozhraní jako Slack, Teams nebo Google Chat.",
    sasTitle: "Migrace ze SAS do Pythonu",
    sasDesc: "Modernizujte svou datovou analytickou infrastrukturu přechodem ze zastaralých systémů SAS na flexibilní, nákladově efektivní řešení založená na Pythonu.",
    learnMore: "Zjistit více",
  }
};
